module.exports = __webpack_public_path__ + "resources/img/img_secure_center01_m_en.613b4c78b32c7e7d06efc58b909858b9.png";